@if (requiredFileTypes.length) {
  <alert message="YouHaveToAddAtLeastOneFileForThisAbsenceType" alertType="warning"></alert>
}

@if (requiredFileTypes.length === controlsCount) {
  <form [formGroup]="willBeDeliveredLaterFormGroup">
    @for (fileType of requiredFileTypes; track fileType) {
      <div class="row">
        <div class="col">
          <h3>{{ fileType.Name }}</h3>
          <fileUpload
            (onFilesChange)="onFilesChange($event, fileType.Id)"
            [isDisabled]="!isFileUploadEnabled(fileType.Id)"
            [alreadySavedFiles]="alreadySavedFiles | filterPurely : filterAlreadySavedFiles(fileType.Id)"
          ></fileUpload>
          @if (alreadySavedFiles | filterPurely : filterAlreadySavedFiles(fileType.Id); as files) {
            @if (files && files?.length > 0) {
              <div class="wrapper">
                @for (file of files; track file) {
                  <div class="file-item-wrapper">
                    <mat-icon>description</mat-icon>
                    <span class="label">{{ file.Name }}</span>
                    <mat-icon>find_in</mat-icon>
                    <button class="show-file-button" mat-icon-button (click)="onShowAbsenceClick(file.AbsenceId, file.WorkerFileId, file.Name)">
                      <mat-icon>find_in_page</mat-icon>
                    </button>
                  </div>
                }
              </div>
            }
          }
          @if (isCheckboxVisible()) {
            <mat-checkbox
              class="will-be-delivered-later-chx"
              [formControlName]="'willBeDeliveredLater_' + fileType.Id"
              (change)="onCheckboxChange($event, fileType.Id)"
              color="primary"
              >
              {{ 'FFQ-48HoursForFile' | translate }}
            </mat-checkbox>
          }
        </div>
      </div>
    }
  </form>
}
